// extracted by mini-css-extract-plugin
module.exports = {"container":"DeleteModal_container__17oZW"};